import React from 'react';
import { motion } from 'framer-motion';
import { Dog, PawPrint, ClipboardList, ArrowLeft, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import BackButton from './BackButton';

const ContextView = ({ 
    handleBack, 
    petName = "", 
    context, 
    setContext,
    onContinue,
    userCurrentContext,
    setUserCurrentContext
}) => (
    <motion.div
        key="context"
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -100 }}
        className="relative"
    >
        {/* Header Section */}
        <div className="relative p-6 sm:p-8 text-center border-b bg-gradient-to-r from-amber-100/50 via-amber-50/50 to-amber-100/50">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-amber-300 to-amber-500 rounded-b-lg" />

            <BackButton onClick={handleBack} />
            <div className="mx-auto mb-4 relative">
                <motion.div
                    initial={{ rotate: 0 }}
                    animate={{ rotate: [0, 12, 0] }}
                    transition={{ duration: 2, repeat: Infinity, repeatType: "reverse", ease: "easeInOut" }}
                    className="w-16 h-16 sm:w-20 sm:h-20 mx-auto bg-gradient-to-br from-amber-400 to-amber-500 rounded-2xl shadow-lg flex items-center justify-center"
                >
                    <ClipboardList className="w-10 h-10 sm:w-12 sm:h-12 text-white" />
                </motion.div>
                <motion.div
                    animate={{ y: [0, -4, 0] }}
                    transition={{ duration: 2, repeat: Infinity }}
                    className="absolute -bottom-2 right-1/2 transform translate-x-10"
                >
                    <PawPrint className="w-5 h-5 sm:w-6 sm:h-6 text-amber-600" />
                </motion.div>
            </div>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="space-y-3"
            >
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-amber-900">
                    {petName ? `Cuéntanos sobre ${petName}` : 'Cuéntanos sobre tu mascota'}
                </h2>
                <p className="text-amber-700 text-base sm:text-lg max-w-md mx-auto">
                    Ayúdanos a entender mejor su situación actual
                </p>
            </motion.div>
        </div>

        {/* Content Section */}
        <div className="p-4 sm:p-6 md:p-8">
            <div className="max-w-2xl mx-auto space-y-6">
                {/* Context Input Section */}
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="space-y-4"
                >
                    <div className="flex items-center justify-between gap-3">
                        <div className="flex items-center gap-2">
                            <ClipboardList className="h-5 w-5 text-amber-500" />
                            <span className="text-gray-800 font-medium">
                                Contexto de la Evaluación
                            </span>
                        </div>
                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            className="px-2.5 py-1 rounded-full bg-amber-100 text-amber-600 text-sm font-medium"
                        >
                            opcional
                        </motion.div>
                    </div>

                    <textarea
                        value={userCurrentContext}
                        onChange={(e) => setUserCurrentContext(e.target.value)}
                        placeholder={`¿Has notado cambios en ${petName || 'tu mascota'}? Cuéntanos sobre su comportamiento, apetito, actividad física o cualquier otra observación relevante...`}
                        className="w-full min-h-[12rem] p-4 rounded-xl border-2 border-amber-100 focus:border-amber-400 
                                 text-gray-600 placeholder:text-gray-500 focus:placeholder:text-gray-400
                                 resize-none transition-colors focus:outline-none"
                    />
                </motion.div>

                {/* Continue Button */}
                <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={onContinue}
                    className={cn(
                        "w-full p-4 rounded-xl font-medium",
                        "transition-all duration-200",
                        "flex items-center justify-center gap-3",
                        "relative overflow-hidden",
                        "bg-gradient-to-r from-amber-500 to-amber-600 text-white shadow-md hover:shadow-lg"
                    )}
                >
                    <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 animate-shimmer" />
                    <Dog className="w-5 h-5" />
                    <span className="text-lg">Continuar</span>
                    <ArrowRight className="w-5 h-5" />
                </motion.button>

                {/* Skip Button */}
                {/* <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => onContinue()}
                    className="w-full p-3 rounded-xl font-medium text-amber-600 hover:text-amber-700
                             hover:bg-amber-50 transition-colors text-sm"
                >
                    Omitir por ahora
                </motion.button> */}
            </div>
        </div>
    </motion.div>
);

export default ContextView;